/* eslint-disable */

// import external dependencies
import 'jquery';

// Import everything from autoload
;

// import local dependencies
import Router from './util/Router';
import common from './routes/common';
import templateContactPage from './routes/template-contacts-page';
import home from './routes/home';
import blog from './routes/blog';
import archiveProductsData from './routes/archive-products';
import singleProduct from './routes/single-product';
import templatePromoPage from './routes/template-promo-page';

/** Populate Router instance with DOM routes */
const routes = new Router({
  // All pages
  common,
  //Contact Page
  templateContactPage,
  //Font Page
  home,
  //Consigli Arredo
  blog,
  //Archive Products
  archiveProductsData,
  //Single Product
  singleProduct,
  //Promo Page
  templatePromoPage,
});

// Load Events
jQuery(document).ready(() => routes.loadEvents());



// WEBPACK FOOTER //
// ./scripts/main.js